import { useRef, useCallback } from 'react';

/**
 * useBackdropClose - Stänger en modal endast vid ett ÄKTA backdrop-klick.
 *
 * Bakgrund: modaler som stänger på "klick utanför" via overlayns onClick stängs
 * felaktigt när man markerar text i ett fält och råkar släppa musen utanför
 * innehållet (mousedown inne → mouseup på overlay → click på overlay → stäng).
 *
 * Lösning: stäng bara om BÅDE mousedown OCH click skedde på själva overlayn.
 *
 * Användning:
 *   const backdrop = useBackdropClose(onClose);
 *   <div className="fixed inset-0 ..." {...backdrop}> ...innehåll... </div>
 *
 * @param {Function} onClose
 * @returns {{ onMouseDown: Function, onClick: Function }}
 */
export default function useBackdropClose(onClose) {
  const downOnOverlay = useRef(false);

  const onMouseDown = useCallback((e) => {
    downOnOverlay.current = e.target === e.currentTarget;
  }, []);

  const onClick = useCallback((e) => {
    if (e.target === e.currentTarget && downOnOverlay.current) {
      onClose?.();
    }
    downOnOverlay.current = false;
  }, [onClose]);

  return { onMouseDown, onClick };
}
